import {
  LayoutDashboard, Users, CheckSquare2, MessageSquare, Phone, Star, BarChart3, GraduationCap,
} from 'lucide-react';

// Модули верхнего уровня: порядок, иконки и ключи подписей. Используется верхней панелью и настройками.
export const NAV_ITEMS = [
  { key: 'dashboard', icon: LayoutDashboard, labelKey: 'bottomNav.dashboard' },
  { key: 'contacts',  icon: Users,           labelKey: 'bottomNav.contacts'  },
  { key: 'tasks',     icon: CheckSquare2,    labelKey: 'bottomNav.tasks'     },
  { key: 'education', icon: GraduationCap,   labelKey: 'bottomNav.education' },
  { key: 'inbox',     icon: MessageSquare,   labelKey: 'bottomNav.inbox'     },
  { key: 'calls',     icon: Phone,           labelKey: 'bottomNav.calls'     },
  { key: 'reviews',   icon: Star,            labelKey: 'bottomNav.reviews'   },
  { key: 'analytics', icon: BarChart3,       labelKey: 'bottomNav.analytics' },
];
